/**
 * MIADI Production - Main JavaScript
 * Hlavní inicializační soubor
 */

// Import komponent (v produkci by se použily ES moduly)
// Pro jednoduchost jsou všechny funkce v tomto souboru

// Flag aby se initAll zavolal jen jednou
let initialized = false;

// Inicializační funkce pro všechny komponenty
function initAll() {
  if (initialized) {
    return;
  }
  initialized = true;

  initNavbar();
  initScrollAnimations();
  initReferencesFilter();
  initVideoModal();
  initBTSSlider();
  initContactForm();
  initBackToTop();
  // initLanguageSwitcher(); // Disabled - using Polylang links instead
  initHeroVideo();
}

// Fallback - zavolej initAll hned pokud je document už ready, jinak počkej na jQuery ready
if (document.readyState === 'loading') {
  // Document se ještě načítá, použij jQuery ready
  jQuery(document).ready(initAll);
} else {
  // Document je už načtený, zavolej hned
  initAll();
}

/**
 * Navbar - Navigace
 */
function initNavbar() {
  const navbar = document.getElementById('navbar');
  const navbarToggle = document.getElementById('navbar-toggle');
  const navbarNav = document.getElementById('navbar-nav');
  const navbarLinks = document.querySelectorAll('.navbar-link');
  const backdrop = document.getElementById('navbar-backdrop');

  // Defensive check - if elements don't exist, exit early
  if (!navbar || !navbarToggle || !navbarNav || !backdrop) {
    console.warn('Navbar elements not found');
    return;
  }

  let lastScrollY = window.scrollY;
  let ticking = false;

  // Scroll efekt - ztmavení a skrytí/zobrazení
  function handleScroll() {
    const currentScrollY = window.scrollY;

    // Přidání třídy při scrollu
    if (currentScrollY > 50) {
      navbar.classList.add('is-scrolled');
    } else {
      navbar.classList.remove('is-scrolled');
    }

    // Skrytí při scrollu dolů, zobrazení při scrollu nahoru
    if (currentScrollY > lastScrollY && currentScrollY > 200) {
      navbar.classList.add('is-hidden');
    } else {
      navbar.classList.remove('is-hidden');
    }

    lastScrollY = currentScrollY;
    ticking = false;
  }

  window.addEventListener('scroll', () => {
    if (!ticking) {
      requestAnimationFrame(handleScroll);
      ticking = true;
    }
  });

  // Hamburger menu toggle
  navbarToggle.addEventListener('click', () => {
    navbarToggle.classList.toggle('is-active');
    navbarNav.classList.toggle('is-active');
    backdrop.classList.toggle('is-active');
    document.body.classList.toggle('modal-open');
  });

  // Zavření menu při kliknutí na backdrop
  backdrop.addEventListener('click', () => {
    navbarToggle.classList.remove('is-active');
    navbarNav.classList.remove('is-active');
    backdrop.classList.remove('is-active');
    document.body.classList.remove('modal-open');
  });

  // Zavření menu při kliknutí na odkaz
  navbarLinks.forEach(link => {
    link.addEventListener('click', () => {
      navbarToggle.classList.remove('is-active');
      navbarNav.classList.remove('is-active');
      backdrop.classList.remove('is-active');
      document.body.classList.remove('modal-open');
    });
  });

  // Aktivní sekce při scrollu
  const sections = document.querySelectorAll('section[id]');

  function highlightNavLink() {
    const scrollY = window.scrollY + 100;

    sections.forEach(section => {
      const sectionHeight = section.offsetHeight;
      const sectionTop = section.offsetTop - 100;
      const sectionId = section.getAttribute('id');

      if (scrollY > sectionTop && scrollY <= sectionTop + sectionHeight) {
        navbarLinks.forEach(link => {
          link.classList.remove('is-active');
          if (link.getAttribute('href') === `#${sectionId}`) {
            link.classList.add('is-active');
          }
        });
      }
    });
  }

  window.addEventListener('scroll', highlightNavLink);
}

/**
 * Scroll animace - Intersection Observer
 */
function initScrollAnimations() {
  const animateElements = document.querySelectorAll('.animate-on-scroll, .stagger-item, .animate-from-left, .animate-from-right, .animate-scale');

  const observerOptions = {
    root: null,
    rootMargin: '0px 0px -50px 0px',
    threshold: 0.1
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        // Přestaň sledovat po zobrazení
        observer.unobserve(entry.target);
      }
    });
  }, observerOptions);

  animateElements.forEach(el => observer.observe(el));
}

/**
 * Reference - Filtrace
 */
function initReferencesFilter() {
  const filterButtons = document.querySelectorAll('.filter-btn');
  const referenceCards = document.querySelectorAll('.reference-card');

  filterButtons.forEach(btn => {
    btn.addEventListener('click', () => {
      // Aktivní tlačítko
      filterButtons.forEach(b => b.classList.remove('is-active'));
      btn.classList.add('is-active');

      const filter = btn.getAttribute('data-filter');

      // Filtrace karet
      referenceCards.forEach(card => {
        const category = card.getAttribute('data-category');

        // Přidání třídy pro animaci
        card.classList.add('is-filtering');

        setTimeout(() => {
          if (filter === 'all' || category === filter) {
            card.classList.remove('is-hidden');
          } else {
            card.classList.add('is-hidden');
          }
          card.classList.remove('is-filtering');
        }, 300);
      });
    });
  });
}

/**
 * Video Modal
 */
function initVideoModal() {
  const referenceCards = document.querySelectorAll('.reference-card[data-vimeo]');
  const modalBackdrop = document.getElementById('video-modal-backdrop');
  const modal = document.getElementById('video-modal');
  const modalVideo = document.getElementById('modal-video');
  const modalClose = document.getElementById('modal-close');

  // Exit early if modal elements don't exist
  if (!modalBackdrop || !modal || !modalVideo || !modalClose) {
    return;
  }

  function openModal(vimeoId) {
    modalVideo.src = `https://player.vimeo.com/video/${vimeoId}?autoplay=1&title=0&byline=0&portrait=0`;
    modalBackdrop.classList.add('is-active');
    modal.classList.add('is-active');
    document.body.classList.add('modal-open');
  }

  function closeModal() {
    modalBackdrop.classList.remove('is-active');
    modal.classList.remove('is-active');
    document.body.classList.remove('modal-open');
    // Zastavení videa
    modalVideo.src = '';
  }

  referenceCards.forEach(card => {
    card.addEventListener('click', () => {
      const vimeoId = card.getAttribute('data-vimeo');
      openModal(vimeoId);
    });
  });

  modalClose.addEventListener('click', closeModal);
  modalBackdrop.addEventListener('click', closeModal);

  // Zavření pomocí Escape
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modal.classList.contains('is-active')) {
      closeModal();
    }
  });
}

/**
 * Behind the Scenes - Swiper Slider
 */
function initBTSSlider() {
  const swiperEl = document.querySelector('.bts-swiper');
  if (!swiperEl) return;

  // Inicializace Swiper
  const btsSwiper = new Swiper('.bts-swiper', {
    slidesPerView: 'auto',
    spaceBetween: 24,
    centeredSlides: true,
    freeMode: {
      enabled: true,
      momentum: true,
      momentumRatio: 0.8,
    },
    grabCursor: true,
    navigation: {
      prevEl: '#bts-prev',
      nextEl: '#bts-next',
    },
    breakpoints: {
      0: {
        spaceBetween: 16,
      },
      768: {
        spaceBetween: 24,
      }
    }
  });

  // Play video on click
  const placeholders = swiperEl.querySelectorAll('.bts-video-placeholder');

  placeholders.forEach(placeholder => {
    placeholder.addEventListener('click', () => {
      const vimeoId = placeholder.getAttribute('data-vimeo');
      const wrapper = placeholder.parentElement;

      // Vytvoření iframe
      const iframe = document.createElement('iframe');
      iframe.src = `https://player.vimeo.com/video/${vimeoId}?autoplay=1&title=0&byline=0&portrait=0`;
      iframe.allow = 'autoplay; fullscreen; picture-in-picture';
      iframe.allowFullscreen = true;

      // Nahrazení placeholderu
      wrapper.innerHTML = '';
      wrapper.appendChild(iframe);
    });
  });
}

/**
 * Kontaktní formulář
 */
function initContactForm() {
  const form = document.getElementById('contact-form');
  const successMessage = document.getElementById('form-success');

  if (!form) return;

  form.addEventListener('submit', (e) => {
    e.preventDefault();

    // Validace
    const name = form.querySelector('#name');
    const email = form.querySelector('#email');
    const message = form.querySelector('#message');
    let isValid = true;

    // Reset chyb
    form.querySelectorAll('.is-error').forEach(el => el.classList.remove('is-error'));

    // Validace jména
    if (!name.value.trim()) {
      name.classList.add('is-error');
      isValid = false;
    }

    // Validace emailu
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email.value)) {
      email.classList.add('is-error');
      isValid = false;
    }

    // Validace zprávy
    if (!message.value.trim()) {
      message.classList.add('is-error');
      isValid = false;
    }

    if (isValid) {
      // Simulace odeslání (v produkci by zde byl skutečný fetch)
      form.style.display = 'none';
      successMessage.classList.add('is-visible');

      // V produkci zde bude:
      // const formData = new FormData(form);
      // fetch('/api/contact', { method: 'POST', body: formData })
      //   .then(response => { ... })
    }
  });
}

/**
 * Zpět nahoru tlačítko
 */
function initBackToTop() {
  const backToTop = document.getElementById('back-to-top');

  if (!backToTop) return;

  // Zobrazení/skrytí tlačítka
  window.addEventListener('scroll', () => {
    if (window.scrollY > 500) {
      backToTop.classList.add('is-visible');
    } else {
      backToTop.classList.remove('is-visible');
    }
  });

  // Scroll nahoru
  backToTop.addEventListener('click', () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  });
}

/**
 * Přepínač jazyků
 */
function initLanguageSwitcher() {
  const langButtons = document.querySelectorAll('.language-btn');
  const savedLang = localStorage.getItem('language') || 'cs';

  // Nastavení aktivního jazyka při načtení
  langButtons.forEach(btn => {
    if (btn.getAttribute('data-lang') === savedLang) {
      btn.classList.add('is-active');
    } else {
      btn.classList.remove('is-active');
    }
  });

  // Přepínání jazyka
  langButtons.forEach(btn => {
    btn.addEventListener('click', () => {
      const lang = btn.getAttribute('data-lang');

      // Update aktivní třídy
      langButtons.forEach(b => b.classList.remove('is-active'));
      btn.classList.add('is-active');

      // Uložení do localStorage
      localStorage.setItem('language', lang);

      // Změna textů (v produkci by byla implementace překladu)
      // updateTranslations(lang);

      // Pro demo jen reload s parametrem
      // window.location.href = `?lang=${lang}`;
    });
  });
}

/**
 * Hero video placeholder handling
 */
function initHeroVideo() {
  const video = document.querySelector('.hero-video');
  const placeholder = document.getElementById('hero-placeholder');

  if (!video || !placeholder) return;

  // Skrytí placeholderu když se video načte
  video.addEventListener('canplay', () => {
    placeholder.style.display = 'none';
  });

  // Zobrazení placeholderu při chybě
  video.addEventListener('error', () => {
    placeholder.style.display = 'flex';
  });

  // Pokud video nemá zdroj, zobraz placeholder
  if (!video.querySelector('source')?.src) {
    placeholder.style.display = 'flex';
  }
}

/**
 * Smooth scroll pro kotvy
 */
function initSmoothScroll() {
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function(e) {
      e.preventDefault();
      const target = document.querySelector(this.getAttribute('href'));

      if (target) {
        const navbar = document.querySelector('.navbar');
        const navbarHeight = navbar.offsetHeight;
        const targetTop = target.getBoundingClientRect().top + window.scrollY;
        const currentScroll = window.scrollY;

        // Určení směru scrollu
        const isScrollingUp = targetTop < currentScroll;

        // Offset podle směru:
        // - Nahoru: navbar se zobrazí, potřebujeme plný offset
        // - Dolů: navbar se skryje, offset minimální
        const offset = isScrollingUp ? navbarHeight : 0;

        const targetPosition = targetTop - offset;

        window.scrollTo({
          top: targetPosition,
          behavior: 'smooth'
        });
      }
    });
  });
}

// Inicializuj smooth scroll
if (document.readyState === 'loading') {
  jQuery(document).ready(initSmoothScroll);
} else {
  initSmoothScroll();
}
